<mat-card
  [ngClass]="{ popcorn: data.id === 67 || data.id === 84 || data.id === 3 }"
>
  <img
    *ngIf="data.is_hot"
    class="hot_platform"
    src="../../../../assets/images/hot-platform.webp"
    alt=""
    width="67"
    height="48"
  />
  <!-- <div class="help" *ngIf="data.help_image || data.help_link">
    <a (click)="openHelp()">使用帮助</a>
  </div> -->
  <app-image [fileid]="data.icon" [radius]="8"></app-image>
  <div class="title">{{ data.name }}</div>
  <div class="desc">{{ data.description }}</div>

  <!-- <div class="tags">
    <app-platform-tag *ngFor="let tag of data.tags" [text]="tag">
    </app-platform-tag>
  </div> -->
  <div class="sale">
    <!-- <img src="../../../../assets/images/hot.png" />
    <span class="count">
      已售:
      {{ data.order_count | number }}
    </span> -->
    <div class="help" *ngIf="data.help_image || data.help_link">
      <a (click)="openHelp()">使用帮助</a>
    </div>

    <div class="spacer"></div>
    <div class="price">
      <ng-container *ngIf="data.id === 67 || data.id === 84 || data.id === 3">
        <!-- 爆米花 || 借个号 -->
        <span class="discount" *ngIf="data.id === 67"> 全家桶八八折 </span>
        <span class="discount" *ngIf="data.id === 84"> 送三个月 </span>
        <span class="discount" *ngIf="data.id === 3"> 限时8折 </span>
      </ng-container>
      <span class="rmb">￥</span>
      <span class="price">
        {{ data.price | number }}
      </span>
      <span class="duration">
        /
        <ng-container *ngIf="data.price_duration === 'Year'">年</ng-container>
        <ng-container *ngIf="data.price_duration === 'Month'">月</ng-container>
        <ng-container *ngIf="data.price_duration === 'Halfyear'"
          >半年</ng-container
        >
        <ng-container *ngIf="data.price_duration === 'Season'"
          >季度</ng-container
        >
        <ng-container *ngIf="data.price_duration === 'Unit'">个</ng-container>
        <ng-container *ngIf="data.price_duration === 'Frequency'"
          >次</ng-container
        >
      </span>
    </div>
  </div>
  <div class="divider"></div>

  <button
    mat-raised-button
    color="primary"
    class="purchase"
    (click)="purchase()"
  >
    购票上车
  </button>
</mat-card>
